module.exports = __webpack_public_path__ + "static/media/dobsovic.3f796d50.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/devdata/resources/dobsovic.jpg
// module id = 552
// module chunks = 0